import React from "react";

const PrecisionAuditAssetsSection = () => {
  return (
    <>
      <section className="container px-3 pt-5 mt-5 mb-3">
        <div className="row bg-secondary rounded-3 align-items-lg-center justify-content-center p-5">
          <div className="col-lg-5 col-md-5 offset-lg-1 text-center text-md-start mb-4 mb-lg-0">
            <h2 className="h2 mb-sm-4">
              Precision Auditing Built for Asset Owners;
            </h2>
            <p className="pb-2 pb-md-3 mb-3">
              Orbix is more than auditing software—it’s your managed compliance
              partner. Our expert auditors apply deep industry knowledge and
              advanced AI to validate inspections against specs and standards in
              real time. This fusion ensures every inspection is accurate,
              compliant, and audit-ready—just what asset owners demand.
            </p>
          </div>
          <div className="col-lg-6 col-md-7 mt-4 pt-2">
            <div className="pe-lg-5 ms-lg-5">
              <img
                src="assets/services_img/precision_audit_assets_img.png"
                className="rounded-3"
                alt="Image"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrecisionAuditAssetsSection;